import { useState } from "react"
import { useQuickBooksAuthorizeQuery } from "./quickBooksQueries"
import { QuickBooksAuthorize } from "./quickBooksModel"

const QuickBooksConnectButton = () => {
    const [isHover, setIsHover] = useState(false)
    const quickBooksDisconnectMutation = useQuickBooksAuthorizeQuery((data: QuickBooksAuthorize) => {
        window.open(data?.redirectTo, "_self")
    })

    return <>
        <span>
            { !isHover && 
                <img
                    src="/images/C2QB_green_btn_med_default.svg"
                    onMouseEnter={() => setIsHover(true)}
                />
            }
            { isHover && 
                <img
                    src="/images/C2QB_green_btn_med_hover.svg"
                    style={{cursor: 'pointer'}}
                    onMouseLeave={() => setIsHover(false)}
                    onClick={() => quickBooksDisconnectMutation.mutate()}
                />
            }
        </span>
    </>
}

export default QuickBooksConnectButton